import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { StaffService } from '../services/staff/staff.service';
import { CompetenciesService } from '../services/competencies.service';
import { Observable, combineLatest } from 'rxjs';

@Component({
  selector: 'app-digital-card',
  templateUrl: './digital-card.component.html',
  styleUrls: ['./digital-card.component.scss']
})
export class DigitalCardComponent implements OnInit {

  userId: String
  userDetails
  profilePic: String
  isProfile = false
  isLoading = false
  displayedColumns: string[] = ['no', 'title', 'date']
  dataSource: MatTableDataSource<any>;
  type: String
  noDataMsg = {
    title: "No Competency!",
    data: "There are no competency of this user"
  }
  isNoData = false

  constructor(
    public route: ActivatedRoute,
    public _staffService: StaffService,
    public _competenciesService: CompetenciesService
  ) {
    this.dataSource = new MatTableDataSource<any>([]);
  }

  ngOnInit(): void {
    combineLatest(this.route.params, this.route.queryParams).subscribe(data => {
      console.log("data of params and query params", data)
      this.type = data[1]['type']
      this.userId = data[0]['id']
      this.getSingleUserDetails()
      this.isLoading = true
    })
    // this.route.params.subscribe((param) => {
    //   console.log("NEW PAGE USER ID", param)
    //   if (param && param.id) {
    //     this.userId = param.id
    //     this.getSingleUserDetails()
    //     this.isLoading = true
    //   }
    // })

  }





  // API CALL 


  /**
   * Get Operative user details with their selected competency list after scan QR code
   */
  getSingleUserDetails() {
    console.log("SINGLE USER API CALL FOR COMPETENCY DATA", this.userId, this.type)
    this._competenciesService.getUserDetails(this.userId, this.type).subscribe((data) => {
      this.userDetails = data
      if (this.userDetails && this.userDetails.profilePic) {
        this.profilePic = this.userDetails.profilePic.path
        this.isProfile = true
      }
      if (this.userDetails && this.userDetails.selectedCompetencies && this.userDetails.selectedCompetencies.length) {
        this.dataSource = this.userDetails.selectedCompetencies
      } else this.isNoData = true
      console.log("THIS IS THE DATA OF ONE OPERATIVE USER", this.userDetails, this.profilePic, this.isProfile)
      this.isLoading = false
    }, error => {
      console.log("ERROR WHILE GET DATA", error)
      this.isLoading = false
    })
  }

}
